import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useGlobalState } from '@/hooks/useGlobalState';
import { Loading } from '@/components/feedback/Loading';
import { b2cConfigured } from './b2c';
import { hasSignedOut } from './sessionLifecycle';

/** Only development without B2C can use the sample-data workspace. */
export function AuthenticatedRoute() {
  const { state } = useGlobalState();
  useEffect(() => {
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted)
        window.location.replace(hasSignedOut() ? '/signin' : window.location.href);
    };
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, []);
  if (hasSignedOut()) return <Navigate to="/signin" replace />;
  if (import.meta.env.DEV && !b2cConfigured) return <Outlet />;
  if (state.authRestoring) return <Loading minHeight="100dvh" />;
  return state.access ? <Outlet /> : <Navigate to="/signin" replace />;
}
